var _typeof = require("/builds/globalhop/dashboard/node_modules/@babel/runtime/helpers/typeof");

module.exports = isPromise;

function isPromise(obj) {
  return !!obj && (_typeof(obj) === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}